<template>
  <v-widget
    :title="$t('Customers')"
    class="mb-4"
  >
    <div slot="widget-content">
      <v-data-table
        v-model="group.customers"
        :loading="loading"
        :headers="headers"
        :items="customers"
        :rows-per-page-text="$t('Rows per page')"
        :pagination.sync="pagination"
        :total-items="total"
        show-select
        select-all
        class="elevation-1"
        item-key="id"
      >
        <v-progress-linear
          slot="progress"
          color="primary"
          indeterminate
        />

        <template v-slot:items="props">
          <customer-group-customers-data-table-row
            :props="props"
          />
        </template>
        <template v-slot:pageText="props">
          <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
        </template>
      </v-data-table>
    </div>
  </v-widget>
</template>

<script>
import CustomerGroupCustomersDataTableRow from './CustomerGroupCustomersDataTableRow'
import CustomerService from '@/modules/Customers/service.js'

export default {
  name: 'CustomerGroupCustomers',

  components: {
    CustomerGroupCustomersDataTableRow
  },

  props: {
    group: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: 'name'
      },
      total: 0,
      loading: false,
      customers: []
    }
  },

  computed: {
    headers () {
      return [
        { text: this.$t('Name'), value: 'fullName' },
        { text: this.$t('Email'), value: 'email' }
      ]
    }
  },

  watch: {
    pagination: function () {
      this.getProducts()
    }
  },

  methods: {
    async getProducts () {
      this.loading = true
      const res = await CustomerService.loadCustomers(this.pagination)
      this.customers = res.collection
      this.total = res.page.total
      this.loading = false
    }
  }
}
</script>
